import { MedicalConditionConditionType } from "../../../Utilities";

export function getConditionTypeLabels(conditionType: MedicalConditionConditionType | null) {
	switch (conditionType) {
		case MedicalConditionConditionType.Allergy:
			return {
				medicalConditionLabel: "Allergy",
				pluralMedicalConditionLabel: "Allergies",
			};
		case MedicalConditionConditionType.FoodIntolerance:
			return {
				medicalConditionLabel: "Food Intolerance",
				pluralMedicalConditionLabel: "Food Intolerances",
			};
		case MedicalConditionConditionType.MedicalCondition:
		default:
			return {
				medicalConditionLabel: "Medical Condition",
				pluralMedicalConditionLabel: "Medical Conditions",
			};
	}
}
